import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { branch, compose, lifecycle, renderComponent, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import { fullName, isOrganizationPlan, getPlanByUserIndustry, getPlanFreeTrialDaysByPlanId } from '../../../services';
import { stripeConfigSelector } from '../../../state/modules/configuration/selectors';
import { userActions } from '../../../state/modules/user';
import Loading from '../loading';
import CreditCardForm from './credit-card-form';
import { getIndustryFromIdentifier, getNext, getOnboardingProcessFromPath } from './industry';
/**
 * Provides billing (payment) information page.
 */
const Billing = ({
  config,
  selectedPlan,
  user,
  nextUrl,
  freeTrialDays,
  userIndustryName
}) => (
    <section id='content--signup'>
      <Grid>
        <h1 className="text-center">Hi {fullName(user)}, start your {freeTrialDays} day free trial</h1>
        <Row className='no-gutter'>
          <Col xs={12} sm={6}>
            <CreditCardForm
              selectedPlan={selectedPlan}
              nextUrl={nextUrl}
              freeTrialDays={freeTrialDays}
              userIndustryName={userIndustryName}
            />
          </Col>
          <Col xs={12} sm={5} smOffset={1}>
            <h2>Facts about the free trial</h2>
            <p>You won't be charged unless you choose to stick with us after your {freeTrialDays} day free trial.</p>
            <p>You can cancel at any time. This is a no-obligation free trial.</p>
            {
              isOrganizationPlan(selectedPlan) ?
                <p>Your subscription price will automatically adjust based on how many active users you have at any time.</p> :
                null
            }
          </Col>
        </Row>
      </Grid>
    </section>
  );

const mapStateToProps = (state) => ({
  config: stripeConfigSelector(state),
  plans: state.payment.plans,
  session: state.session,
  user: state.user.currentUser,
  userProfile: state.user.profile,
  industriesWithCpdCategorys: state.industry.industriesWithCpdCategorys
});

const mapDispatchToProps = (dispatch) => ({
  getUser: bindActionCreators(userActions.user.getCurrent, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const {
        getUser,
        user
      } = this.props;

      if (!user.id) {
        getUser();
      }
    }
  }),
  branch(
    ({
      config,
      plans,
      user: {
        id: hasUser
      }
    }) => plans.length === 0 || !hasUser || !config,
    renderComponent(Loading)
  ),
  withProps(({
    userProfile
  }) => ({
    userIndustryName: userProfile !== undefined ? userProfile.stat.industryName : "",
  })),
  withProps(({
    config: {
      plansInUse,
    },
    plans,
    selectedPlan,
    user,
    userIndustryName,
    match: {
      path,
      params: {
        industryIdentifier
      }
    },
    industriesWithCpdCategorys
  }) => ({
    selectedPlan: selectedPlan || getPlanByUserIndustry(plansInUse, plans, user, userIndustryName),
    nextUrl: getNext(getIndustryFromIdentifier(industryIdentifier, industriesWithCpdCategorys), getOnboardingProcessFromPath(path))()
  })),
  withProps(({
    selectedPlan,
    config: {
      plansInUse,
    },
  }) => ({
    freeTrialDays: getPlanFreeTrialDaysByPlanId(plansInUse, selectedPlan.id),
  })),
  branch(
    ({ selectedPlan }) => !selectedPlan,
    renderComponent(() => (
      <Redirect to={routes.onboarding.choosePlan} push />
    ))
  )
)(Billing);



// WEBPACK FOOTER //
// ./src/containers/pages/onboarding/billing.js